export default __webpack_public_path__ + "static/media/Control.406c1fd9.svg";